import { add_to_cart_event } from "./ecommerce/add_to_cart";
import { add_payment_info_event } from "./ecommerce/add_payment_info";
import { checkout_event } from "./ecommerce/checkout_event";
import { page_identifier_checkout } from "./page_identifier/checkout";
import { view_item_event } from "./ecommerce/view_item";
import { purchase_event } from "./ecommerce/purchase";

const events = {
    'analytics.interaction.ecommerce.add-to-cart': () => add_to_cart_event.triggerEvent(),
    'analytics.interaction.ecommerce.add-payment-info': () => add_payment_info_event.triggerEvent(),
    'analytics.view.ecommerce.checkout': () => checkout_event.triggerEvent(),
    'analytics.view.default.page_identifier': () => page_identifier_checkout.triggerEvent(),
    'analytics.view.ecommerce.pdp': () => view_item_event.triggerEvent(),
    'analytics.view.ecommerce.purchase': () => purchase_event.triggerEvent()
};


export default function analyticsEventListeners() {

    Object.keys(events).forEach((key) => document.addEventListener(key, () => events[key]()));
}



